export const PALM1_COAUTHORS = [
  'Aakanksha Chowdhery',
  'Sharan Narang',
  'Jacob Devlin',
  'Maarten Bosma',
  'Gaurav Mishra',
  'Adam Roberts',
  'Paul Barham',
  'Hyung Won Chung',
  'Charles Sutton',
  'Sebastian Gehrmann',
  'Parker Schuh',
  'Kensen Shi',
  'Sasha Tsvyashchenko',
  'Joshua Maynez',
  'Abhishek Rao',
  'Parker Barnes',
  'Yi Tay',
  'Noam Shazeer',
  'Vinodkumar Prabhakaran',
  'Nan Du',
  'Ben Hutchinson',
  'Reiner Pope',
  'James Bradbury',
  'Jacob Austin',
  'Michael Isard',
  'Guy Gur-Ari',
  'Pengcheng Yin',
  'Toju Duke',
  'Anselm Levskaya',
  'Sanjay Ghemawat',
  'Sunipa Dev',
  'Henryk Michalewski',
  'Xavier Garcia',
  'Vedant Misra',
  'Kevin Robinson',
  'Liam Fedus',
  'Denny Zhou',
  'Daphne Ippolito',
  'David Luan',
  'Hyeontaek Lim',
  'Barret Zoph',
  'Alexander Spiridonov',
  'Ryan Sepassi',
  'David Dohan',
  'Shivani Agrawal',
  'Mark Omernick',
  'Andrew M. Dai',
  'Thanumalayan Sankaranarayana Pillai',
  'Marie Pellat',
  'Aitor Lewkowycz',
  'Erica Moreira',
  'Rewon Child',
  'Oleksandr Polozov',
  'Katherine Lee',
  'Zongwei Zhou',
  'Xuezhi Wang',
  'Brennan Saeta',
  'Mark Diaz',
  'Orhan Firat',
  'Michele Catasta',
  'Jason Wei',
  'Kathy Meier-Hellstern',
  'Douglas Eck',
  'Jeff Dean',
  'Slav Petrov',
  'Noah Fiedel',
] as const;

export const PALM2_COAUTHORS = [
  'Rohan Anil',
  'Andrew M. Dai',
  'Orhan Firat',
  'Melvin Johnson',
  'Dmitry Lepikhin',
  'Alexandre Passos',
  'Siamak Shakeri',
  'Emanuel Taropa',
  'Paige Bailey',
  'Zhifeng Chen',
  'Eric Chu',
  'Jonathan H. Clark',
  'Laurent El Shafey',
  'Yanping Huang',
  'Kathy Meier-Hellstern',
  'Gaurav Mishra',
  'Erica Moreira',
  'Mark Omernick',
  'Kevin Robinson',
  'Sebastian Ruder',
  'Yi Tay',
  'Kefan Xiao',
  'Yuanzhong Xu',
  'Yujing Zhang',
  'Gustavo Hernandez Abrego',
  'Junwhan Ahn',
  'Jacob Austin',
  'Paul Barham',
  'Jan Botha',
  'James Bradbury',
  'Siddhartha Brahma',
  'Kevin Brooks',
  'Michele Catasta',
  'Yong Cheng',
  'Colin Cherry',
  'Christopher A. Choquette-Choo',
  'Aakanksha Chowdhery',
  'Clément Crepy',
  'Shachi Dave',
  'Mostafa Dehghani',
  'Sunipa Dev',
  'Jacob Devlin',
  'Mark Díaz',
  'Nan Du',
  'Ethan Dyer',
  'Vlad Feinberg',
  'Fangxiaoyu Feng',
  'Vlad Fienber',
  'Markus Freitag',
  'Xavier Garcia',
  'Sebastian Gehrmann',
  'Lucas Gonzalez',
  'Guy Gur-Ari',
  'Steven Hand',
  'Hadi Hashemi',
  'Le Hou',
  'Joshua Howland',
  'Andrea Hu',
  'Jeffrey Hui',
  'Jeremy Hurwitz',
  'Michael Isard',
  'Abe Ittycheriah',
  'Matthew Jagielski',
  'Wenhao Jia',
  'Kathleen Kenealy',
  'Maxim Krikun',
  'Sneha Kudugunta',
  'Chang Lan',
  'Katherine Lee',
  'Benjamin Lee',
  'Eric Li',
  'Music Li',
  'Wei Li',
  'YaGuang Li',
  'Jian Li',
  'Hyeontaek Lim',
  'Hanzhao Lin',
  'Zhongtao Liu',
  'Frederick Liu',
  'Marcello Maggioni',
  'Aroma Mahendru',
  'Joshua Maynez',
  'Vedant Misra',
  'Maysam Moussalem',
  'Zachary Nado',
  'John Nham',
  'Eric Ni',
  'Andrew Nystrom',
  'Alicia Parrish',
  'Marie Pellat',
  'Martin Polacek',
  'Alex Polozov',
  'Reiner Pope',
  'Siyuan Qiao',
  'Bryan Richter',
  'Parker Riley',
  'Alex Castro Ros',
  'Aurko Roy',
  'Brennan Saeta',
  'Rajkumar Samuel',
  'Renee Shelby',
  'Ambrose Slone',
  'Daniel Smilkov',
  'David R. So',
  'Daniel Sohn',
  'Simon Tokumine',
  'Dasha Valter',
  'Vijay Vasudevan',
  'Kiran Vodrahalli',
  'Xuezhi Wang',
  'Pidong Wang',
  'Zirui Wang',
  'Tao Wang',
  'John Wieting',
  'Yuhuai Wu',
  'Kelvin Xu',
  'Yunhan Xu',
  'Linting Xue',
  'Pengcheng Yin',
  'Jiahui Yu',
  'Qiao Zhang',
  'Steven Zheng',
  'Ce Zheng',
  'Weikang Zhou',
  'Denny Zhou',
  'Slav Petrov',
  'Yonghui Wu',
] as const;
